export enum EventType {
    CmdOcrRequest = "cmd-global-ocr-request"
}

export enum Origin {
    CarelonPacs = "Carelon-MBMS-ProviderPortal"
}

export enum Target {
    CarelonOdna = "Carelon-DICA-OCRServices"
}

export enum Routes{
    RequestRoute = "https:\\endpointRoute", 
    CallbackRoute= "https:\\endpointRoute" 
}

